var map = {
	"./awakenings": 270,
	"./awakenings.json": 270,
	"./awakenings.png": 789,
	"./card-bg": 271,
	"./card-bg.json": 271,
	"./card-bg.png": 790,
	"./card-frames": 272,
	"./card-frames.json": 272,
	"./card-frames.png": 791,
	"./font": 273,
	"./font.json": 273,
	"./font.png": 792,
	"./font36": 274,
	"./font36.json": 274,
	"./font36.png": 793,
	"./icons": 275,
	"./icons.json": 275,
	"./icons.png": 794,
	"./latents-1.png": 795,
	"./latents-2.png": 796,
	"./rikuu.png": 772,
	"./types": 276,
	"./types.json": 276,
	"./types.png": 797
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 788
// module chunks = 0